import { Button, useToast } from '@chakra-ui/react';
import { getKeystore } from '../utils/networkConfigStore';
import { Buffer } from 'buffer';

interface KeystoreExportButtonProps {
  networkId: string;
  accountId: string;
}

const KeystoreExportButton = ({ networkId, accountId }: KeystoreExportButtonProps) => {
  const toast = useToast();

  const handleExport = () => {
    const base64 = getKeystore(networkId, accountId);
    if (!base64) {
      toast({ title: 'No keystore found', status: 'error', duration: 3000 });
      return;
    }

    const bytes = Buffer.from(base64, 'base64');
    const blob = new Blob([bytes], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `keystore-${accountId}.bin`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="outline" size="sm" onClick={handleExport}>
      Export Keystore
    </Button>
  );
};

export default KeystoreExportButton;
